const s = {
  name: "RobotMini",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,14c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.7,0,3-1.3,3-3S17.7,14,16,14z M15,17c0-0.6,0.4-1,1-1s1,0.4,1,1
			s-0.4,1-1,1S15,17.6,15,17z"/>
		<path class="st0" d="M21,17c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3s-1.3,3-3,3C22.3,20,21,18.7,21,17z M24,16c-0.6,0-1,0.4-1,1
			s0.4,1,1,1s1-0.4,1-1S24.6,16,24,16z"/>
		<path class="st0" d="M20,0c-2.2,0-4,1.8-4,4c0,1.9,1.3,3.4,3,3.9V10H9v9H5v-5.1c1.7-0.4,3-2,3-3.9H6c0,1.1-0.9,2-2,2
			c-1.1,0-2-0.9-2-2H0c0,1.9,1.3,3.4,3,3.9V21h6v9h7v8H9v2h9V30h4v10h9v-2h-7v-8h7v-9h4v5.1c-1.7,0.4-3,2-3,3.9h2c0-1.1,0.9-2,2-2
			s2,0.9,2,2h2c0-1.9-1.3-3.4-3-3.9V19h-6v-9H21V7.9c1.7-0.4,3-2,3-3.9C24,1.8,22.2,0,20,0z M18,4c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2
			s-0.9,2-2,2C18.9,6,18,5.1,18,4z M11,28v-4h18v4H11z M11,12h18v10H11V12z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as RobotMini
};
